import { render } from "./AnakinNavItem.vue?vue&type=template&id=05055d3e&ts=true"
import script from "./AnakinNavItem.vue?vue&type=script&lang=ts"
export * from "./AnakinNavItem.vue?vue&type=script&lang=ts"

import "./AnakinNavItem.vue?vue&type=style&index=0&id=05055d3e&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__